// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ContestPosts__list":"sp_a bhn_rc bhn_qx bhn_xr","ContestPosts__more":"sp_b bhn_vu bhn_b bhn_va bhn_sv"};